export default "__VITE_ASSET__bG2Z5F54O5TFNy8YdDQQiw__"